var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{class:_vm.customClass,attrs:{"color":_vm.color,"label":"","outlined":"","small":_vm.small}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }